import { render, staticRenderFns } from "./SideBarNav.vue?vue&type=template&id=20794472&scoped=true&"
import script from "./SideBarNav.vue?vue&type=script&lang=js&"
export * from "./SideBarNav.vue?vue&type=script&lang=js&"
import style0 from "./SideBarNav.vue?vue&type=style&index=0&id=20794472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20794472",
  null
  
)

export default component.exports